import { Trans } from 'react-i18next'

import monaLisaPNG from '~/assets/images/art/mona-lisa.png'
import monaLisaWEBP from '~/assets/images/art/mona-lisa.webp'
import { ImageLayoutStyles as PS } from '~/pages/anatomy/quizBinaryChoice/libs/styles/imageLayout'
import { FactCaption } from '~/pages/art/factCard/libs/caption'
import { FactImageWrapper } from '~/pages/art/factCard/libs/imageWrapper'
import {
  ANSWERS,
  greenAccept,
  redCross,
} from '~/pages/onboarding/quizBinaryChoice/libs/constants'
import { Styles as S } from '~/pages/onboarding/quizBinaryChoice/libs/styles'
import { useBinaryChoiceStep } from '~/shared/hooks/useBinaryChoiceStep'
import { TPageProps } from '~/shared/types/commonTypes'

const MONA_LISA_QUESTION = 'Mona Lisa has no eyebrows, they faded over time.'

const MonaLisa = ({ nextPagePath, pageId }: TPageProps) => {
  const { answer, handleAnswer } = useBinaryChoiceStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: MONA_LISA_QUESTION,
  })

  return (
    <PS.Root>
      <PS.StyledContainer>
        <FactImageWrapper>
          <picture>
            <source srcSet={monaLisaWEBP} type="image/webp" />
            <img src={monaLisaPNG} alt="Mona Lisa" />
          </picture>
        </FactImageWrapper>

        <FactCaption>
          <Trans ns="art" i18nKey="onboarding.factCard.didYouKnow" />
        </FactCaption>

        <PS.Question>
          <Trans ns="art" i18nKey="onboarding.factCard.monaLisa.statement" />
        </PS.Question>

        <PS.ButtonWrapper>
          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.no}
            onClick={() => handleAnswer(ANSWERS.no)}
          >
            <S.ButtonIcon src={redCross} alt={ANSWERS.no} />
            <Trans i18nKey={`actions.${ANSWERS.no}`} />
          </S.StyledButton>
          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.yes}
            onClick={() => handleAnswer(ANSWERS.yes)}
          >
            <S.ButtonIcon src={greenAccept} alt={ANSWERS.yes} />
            <Trans i18nKey={`actions.${ANSWERS.yes}`} />
          </S.StyledButton>
        </PS.ButtonWrapper>
      </PS.StyledContainer>
    </PS.Root>
  )
}

export default MonaLisa
